var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"success-wrapper"},[(_vm.isSuccessIcon)?_c('div',{staticClass:"icon"}):_c('div',{staticClass:"icontow"}),_c('div',{staticClass:"thanks"},[_c('div',{staticStyle:{"color":"black"}},[_vm._v(" "+_vm._s(_vm.isSuccessInfo)+" ")]),_c('div',{staticClass:"button",on:{"click":_vm.checkisSuccess}},[_vm._v(" Done ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }